var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-card",
    {
      staticClass: "card",
      class: _vm.classes,
      style: _vm.style,
      attrs: { grow: "" },
    },
    [
      _vm.plain
        ? _c(
            "w-card-title",
            { attrs: { plain: "", subtitle: _vm.subtitle } },
            [
              _vm._v(" " + _vm._s(_vm.modal.title) + " "),
              _c("w-spacer"),
              _c("w-button", {
                attrs: { flat: "", round: "", icon: "times" },
                on: {
                  click: function ($event) {
                    return _vm.close()
                  },
                },
              }),
            ],
            1
          )
        : _c(
            "w-card-title",
            [
              _vm._v(_vm._s(_vm.modal.title)),
              _c("w-spacer"),
              _c(
                "w-link",
                {
                  attrs: { white: "" },
                  on: {
                    click: function ($event) {
                      return _vm.close()
                    },
                  },
                },
                [_c("w-fa", { attrs: { icon: "times" } })],
                1
              ),
            ],
            1
          ),
      _c("iframe", {
        staticClass: "iframe",
        class: { plain: _vm.plain },
        attrs: { src: _vm.modal.data },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }